import { Column, Flex, HorizontalLine } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";

import { useFaireDirectFirstOrderIncentive } from "@faire/retailer/hooks/FaireDirect/useFaireDirectFirstOrderIncentive/useFaireDirectFirstOrderIncentive";
import { useSettingFirstOrderIncetiveForFaireDirectLoggedOut } from "@faire/retailer/settings/useSettingFirstOrderIncetiveForFaireDirectLoggedOut";
import { Perk } from "@faire/retailer/views/faire-direct/sections/PerksSection/__internal__/Perk";
import {
  getPerkValues,
  IPerkValue,
} from "@faire/retailer/views/faire-direct/sections/PerksSection/__internal__/PerkValues";

export const PerksSection: React.FC = () => {
  const isFoiForFD = useSettingFirstOrderIncetiveForFaireDirectLoggedOut();

  const { isMobile } = useViewport();
  const {
    isFaireDirectCreditPercentageBased,
    formattedPercentageBasedNumber,
    formattedMaxPercentageDiscountAmount,
    formattedFixedBasedAmount,
  } = useFaireDirectFirstOrderIncentive();
  const perkValues: IPerkValue[] = getPerkValues({
    isFaireDirectCreditPercentageBased,
    formattedIncentiveAmount: formattedFixedBasedAmount,
    formattedPercentageBasedDiscount: formattedPercentageBasedNumber,
    formattedMaximumPercentageDiscount: formattedMaxPercentageDiscountAmount,
    isFoiForFDDiscount: isFoiForFD,
  });
  return (
    <Column align="center">
      <Spacer height="9x" />
      <Typography variant="pageHeaderSerifRegular" align="center">
        <StrictLocalMsg defaultMessage="Why shop us through Faire?" />
      </Typography>
      <Spacer height="3x" />
      <HorizontalLine width="120px" />
      <Spacer height="6x" />
      <ResponsiveContainer>
        {perkValues.map((value, index) => (
          <Perk value={value} index={index} key={index} />
        ))}
      </ResponsiveContainer>
      <Spacer height={isMobile ? "9x" : 96} />
    </Column>
  );
};

const ResponsiveContainer = styled(Flex).attrs({
  direction: { mobileAndAbove: "column", tabletAndAbove: "row" },
})``;
